import * as types from '@/store/types';

export default {
  [types.LIST_ANSWERS](state, { answers }){
    state.answers = answers;
  },
  [types.FECTH_ANSWERS](state, { answers_user }){
    state.answers_user = answers_user;
  }
};
